var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "markdamagempslisting"
  }, [(_vm.showmarkdamagemps == false) ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    },
    on: {
      "click": function($event) {
        _vm.changescrollcss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Mark Damage MPS"
    },
    on: {
      "click": _vm.markdamagempsfunction
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-2x",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "style": "color: red;"
    }
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("MPS Number  ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mpsnumber),
      expression: "mpsnumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "MPS Number",
      "name": "mpsnumber",
      "id": "description"
    },
    domProps: {
      "value": (_vm.mpsnumber)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchdamageMPS($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mpsnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" (Note: Use comma(,) for multiple MPS numbers)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Mark Damage Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.markdamagezonelist,
      "disabled": _vm.disableflag == true,
      "placeholder": "Select Damage Zone",
      "id": "damagezone",
      "append-to-body": true,
      "name": "damagezone"
    },
    on: {
      "select": _vm.selectZone
    },
    model: {
      value: (_vm.damagezone),
      callback: function($$v) {
        _vm.damagezone = $$v
      },
      expression: "damagezone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Mark Damage Hub/SVC Name ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.DamageHubList,
      "name": "hubname",
      "placeholder": "Select Hub Name",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selectHub
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment Damage Date range ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o' style='font-size: 12px'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "shipmentDamagenDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.shipmentDamagenDate),
      callback: function($$v) {
        _vm.shipmentDamagenDate = $$v
      },
      expression: "shipmentDamagenDate"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('label')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchdamageMPS
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                                        "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]), _vm._v("   \n                                      ")])], 1)])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cargo Shipment Damage Mark Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px",
      "margin-left": "6rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_c('i'), _vm._v(" Download (XLSX)")])])])]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    attrs: {
      "id": "parent"
    }
  }, [_c('custom-expandable-table', {
    key: _vm.expandableKey,
    attrs: {
      "columns": _vm.tableColumn,
      "isViewImage": true,
      "width": true,
      "isEditHidden": true,
      "isViewDetails": true,
      "isViewHidden": true,
      "id": "damagemarkdetails",
      "items": _vm.tableItems,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isDetailsLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isDetailsLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.viewDetails) ? _c('damagemps-details', {
    attrs: {
      "childData": _vm.parentDetails
    }
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('span', {
    class: _vm.arrowscollcss == true ? 'panner arrow1 arrow-left' : 'panner arrow arrow-left',
    attrs: {
      "id": "panLeft",
      "title": "Move to Left",
      "data-scroll-modifier": "-1"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.arrowscollcss == true ? 'panner arrow1 arrow-right' : 'panner arrow arrow-right',
    attrs: {
      "id": "panRight",
      "title": "Move to Right",
      "data-scroll-modifier": "1"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ShowDamageMPSImages = false
      }
    },
    model: {
      value: (_vm.ShowDamageMPSImages),
      callback: function($$v) {
        _vm.ShowDamageMPSImages = $$v
      },
      expression: "ShowDamageMPSImages"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isImageLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isImageLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("Damage MPS Images ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDamageMPSImages
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Uploaded Images\n                            "), _c('div', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("(Click on the image to view it)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.imagearray), function(item) {
    return _c('div', {
      staticClass: "col-md-5"
    }, [_c('br'), _vm._v(" "), (item) ? _c('img', {
      staticStyle: {
        "cursor": "pointer",
        "width": "65px",
        "margin-left": "9rem",
        "height": "65px"
      },
      attrs: {
        "src": item,
        "alt": "NO Image",
        "title": "Open Image"
      },
      on: {
        "click": function($event) {
          _vm.openImage(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item) ? _c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "1rem",
        "margin-left": "20px",
        "margin-right": "10px",
        "margin-top": "1rem"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Download Image"
      },
      on: {
        "click": function($event) {
          _vm.fileview(item)
        }
      }
    }) : _vm._e()])
  }))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.image
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.image)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.caption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.image,
      "src": _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])]), _vm._v(" "), _c('div', [(_vm.showmarkdamagemps == true) ? _c('div', [_c('markdamage-mps', {
    attrs: {
      "parentobj": _vm.parentdata
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7d8d0de","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/DamageMPS/markdamageMPSListing/markdamageMPSListing.component.html
// module id = 1910
// module chunks = 3